import React from 'react';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';

export default function App() {
    return (
        <>


            <MDBRow>
                <h2>News Video Gallery</h2>

                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/Ebb6xDbEQ6Y?si=IzbfwEVVPLDJ5FdW'
                            // https://youtube.com/shorts/Ebb6xDbEQ6Y?si=IzbfwEVVPLDJ5FdW
                            title='YouTube video 1'
                            allowFullScreen
                        ></iframe>
                    </div>
                </MDBCol>

                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/a-hr1HF99Dk'
                            title='YouTube video 2'
                            allowFullScreen
                        ></iframe>
                    </div>
                </MDBCol>

                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/8i9GY2abRpI'
                            title='YouTube video 3'
                            allowFullScreen
                        ></iframe>
                    </div>
                </MDBCol>
            </MDBRow>


            <MDBRow style={{ marginTop: "20px" }}>
                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/iP-Rloxy6D8'
                            title='YouTube video 1'
                            allowFullScreen

                        ></iframe>
                    </div>
                </MDBCol>

                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/NautjJo37mg'
                            title='YouTube video 2'
                            allowFullScreen
                        ></iframe>
                    </div>
                </MDBCol>

                <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                    <div className='ratio ratio-16x9'>
                        <iframe
                            src='https://www.youtube.com/embed/iP-Rloxy6D8'
                            title='YouTube video 3'
                            allowFullScreen
                        ></iframe>
                    </div>
                </MDBCol>
            </MDBRow>

        </>
    );
}
